import { RespostaFinanceiro } from "app/types/pesquisa-orcamento/sub-consultas-notas-fiscais/Financeiro";
import { NotaFiscalFinanceiro } from "./NotaFiscalFinanceiro"
import { useEffect, useRef, useState } from "react";
import React from "react";
import globalMU from "globalMU";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import { DadosNotaFiscal } from "app/types/pesquisa-orcamento/consultas/NotasFiscais";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import microuniversoApi from "app/api/microuniversoApi";
import { DadosDaPesquisaOrcamento } from "app/types/pesquisa-orcamento/PesquisaOrcamento";
import { useMenuConsultasPesquisaOrcamento } from "app/components/pesquisa-orcamento/menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento";
import { useMenuSubConsultasNotaFiscal } from "app/components/pesquisa-orcamento/menu-sub-consultas-nota-fiscal/useMenuSubConsultasNotaFiscal";

export type NotaFiscalFinanceiroContainerProps = {
    notaFiscalSelecionada: Partial<DadosNotaFiscal>
    orcamentoSelecionado: Partial<DadosDaPesquisaOrcamento>
    passos: Dict<string, () => void>,
    onRemover?: () => void,
    onVoltar: () => void,
}

export const NotaFiscalFinanceiroContainer = (props: NotaFiscalFinanceiroContainerProps) => {

    const [dados, setDados] = useState<RespostaFinanceiro[]>([]);

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const onObterDadosFinanceiro = async () => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.NotaFiscalSaida.ContasReceber(
                Number(props.notaFiscalSelecionada.Codigo)
            );

            if (("Error" in resultado)) {
                onVoltar();
                return
            }
            
            setDados(resultado);
        }
        catch (e) {
            tratamentoErroPadrao(e);
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useMenuConsultasPesquisaOrcamento({
        onVoltar:  props.onVoltar,
        orcamentoSelecionado: props.orcamentoSelecionado,
        passos: new Dict(Object.assign({}, props.passos.map)),
    })

    useMenuSubConsultasNotaFiscal({
        notaFiscalSelecionada: props.notaFiscalSelecionada,
        orcamentoSelecionado: props.orcamentoSelecionado,
        onVoltar: () => props.onVoltar(),
        passos: passosInterno.current
    })

    useEffect(() => {
        passosInterno.current.set("Notas Fiscais", () => props.onVoltar())
        passosInterno.current.set("Financeiro", () => { })
        onObterDadosFinanceiro();
    }, [])


    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="NotaFiscalFinanceiroContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={() => onVoltar()}
            />
            
            <NotaFiscalFinanceiro dadosfincaneiro={dados} />
        </>
    )
}